import React from 'react';
import PropTypes from 'prop-types';

import {styled} from '@mui/system';
import Grid from '@mui/material/Grid';

import {concatUrl} from '../helpers/url';
import {getCall} from '../helpers/request';
import GlobalContext from '../helpers/context';
import ProgressSpinner from '../component/atoms/ProgressSpinner';
import JsonView from '../component/jsonLoader/json-loader';
import CustomAccordion from '../component/molecule/CustomAccordion';
import Box from "@mui/material/Box";


const StyledHistory = styled('div')({
    marginTop: 20,
    marginBottom: 30
});

const StyledHistoryHeader = styled(Grid)(({ theme }) =>({
    padding: '10px 41px 10px 16px',
    marginTop: 10,
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.secondary.contrastText,
    fontWeight: theme.custom.font.bold
}));

const StyledHistoryListItem = styled(Grid)(({ theme }) =>({
    fontSize: theme.custom.font.medium
}));

const StyledHistoryItem = styled('div')(({ theme }) =>({
    fontSize: theme.custom.font.medium
}));

const StyledNoData = styled('div')(({ theme }) =>({
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.fontSize,
    marginTop: 30,
    marginBottom: 30,
    textAlign: 'center'
}));


class CurationProfileHistory extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            history: undefined,
            loaded_details: {}
        };

        this.is_mounted = false;
        this.get_curation_profile_history_url = concatUrl(window.ROOT_URL, 'api', 'curation_profile', 'history');

    }

    componentDidMount(){
        this.is_mounted = true;
        if (this.props.curation_profile_id){
            this.loadCurationProfileHistory();
        }
    }

    componentWillUnmount(){
        this.is_mounted = false;
    }

    // +++ load curation profile history +++++++++++++++++++++++++++++++++++++++++++++++

    loadCurationProfileHistoryFailed = () => {
        if(!this.is_mounted) {
            // skip updating component if not mounted to avoid.
            return;
        }

        this.context.displayGlobalError('Backend service failure: Could not load curation profile history.');
    };

    loadCurationProfileHistoryDone = (data, callback_failure) => {
        if(!this.is_mounted) {
            // skip updating component if not mounted to avoid.
            return;
        }

        if (!data) {
            callback_failure();
        }else{
            this.setState({
                history: orderLogs(data.history)
            });
        }
    };

    loadCurationProfileHistory = () => {
        getCall(`${this.get_curation_profile_history_url}?id=${this.props.curation_profile_id}&workspace_id=${this.props.workspace_id}`,
            this.loadCurationProfileHistoryDone,
            this.loadCurationProfileHistoryFailed);
    };

    handleExpansionPanelChange = (log_details, index) => (event) => {
        if(!this.state.loaded_details[index]){
            // add log_details to loaded details
            let loaded_details = this.state.loaded_details;
            loaded_details[index] = log_details;
            this.setState({loaded_details: loaded_details});
        }
    };

     historyList(){
         if(this.state.history === undefined) {
            return (
                <Grid container>
                    <Grid size={12}>
                        <ProgressSpinner/>
                    </Grid>
                </Grid>
            );
        }
        if(this.state.history.length){
            return (
                <div>
                    {this.state.history.map((log, index) => <CustomAccordion
                        key={`log_${index}`}
                        onOpenCallback={this.handleExpansionPanelChange(log.details, index)}
                        summary={
                            <Box sx={{ flexGrow: 1 }}>
                                <StyledHistoryListItem container spacing={2}>
                                    <Grid size={4}>
                                    {log.date_time}
                                    </Grid>
                                    <Grid size={4}>
                                        {log.action}
                                    </Grid>
                                    <Grid size={4}>
                                        {log.user.name}
                                    </Grid>
                                </StyledHistoryListItem>
                            </Box>
                        }
                        content={
                            <StyledHistoryItem>
                                {this.state.loaded_details[index] && <JsonView src={this.state.loaded_details[index]} name="data"/>}
                            </StyledHistoryItem>
                        }
                    />
            )}
                </div>
            );
        }
        return (
            <StyledNoData>
                No history available
            </StyledNoData>
        );
    }

    profileHistory() {
        return (
            <StyledHistory>
                <StyledHistoryHeader container spacing={2}>
                    <Grid size={4}>
                        Date/Time
                    </Grid>
                    <Grid size={4}>
                        Action
                    </Grid>
                    <Grid size={4}>
                        User
                    </Grid>
                </StyledHistoryHeader>
                {this.historyList()}
            </StyledHistory>
        );
    }

    render() {
        return (
            <GlobalContext.Consumer>{() => (
                <div>
                    {this.profileHistory()}
                </div>
            )}
            </GlobalContext.Consumer>
        );
    }
}

function orderLogs(logs, order='date_time'){
    return logs.sort(function(a, b){

        let first = undefined;
        let second = undefined;

        if(order === 'date_time'){
            first = new Date(a[order]);
            second = new Date(b[order]);
        }

        if (first < second)
            return 1;
        if (first > second)
            return -1;
        return 0;
    });
}

CurationProfileHistory.contextType = GlobalContext;

CurationProfileHistory.propTypes = {
    curation_profile_id: PropTypes.number.isRequired,
    workspace_id: PropTypes.number.isRequired
};

export default CurationProfileHistory;
